import React, { useState } from 'react';
import { Box, Typography, TextField, FormControlLabel, Checkbox, Button, Link, Divider } from '@mui/material';
import SocialButtons from './SocialButtons';
import useSignin from '../../../hooks/useSignin';
import { useAlert } from '../../../context/AlertContext';
import { useAuth } from '../../../context/AuthContext';
import { colors } from '../../../styles/Variables';
import { pushEvent } from '../../../utils/dataLayer';

const CadastroForm = ({ setIsLogin }) => {
    const [nome, setNome] = useState('');
    const [emailCad, setEmailCad] = useState('');
    const [senhaCad, setSenhaCad] = useState('');
    const [ofertas, setOfertas] = useState(true);
    const [aceitaTermos, setAceitaTermos] = useState(false);

    const { signin, loading, error } = useSignin();
    const { auth } = useAuth();
    const { showAlert } = useAlert();

    const handleSignin = async (e) => {
        e.preventDefault();

        if (!aceitaTermos) {
            showAlert('Você precisa aceitar os termos de uso', 'error');
            return;
        }

        const response = await signin(emailCad, senhaCad, nome);

        if(response){
            pushEvent('user-signup', {
                user: response.data?.id ? { id: response.data.id } : undefined,
                lastUrl: window.location.href,
            });
            showAlert("Usuário criado com sucesso", 'success');
            setIsLogin(true)
        } else {
            showAlert(error, 'error');
        }

    };

    return (
        <Box component="form" onSubmit={handleSignin} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#999', letterSpacing: 1, fontSize: 12 }}>
            N O M E *
        </Typography>
        <TextField placeholder="Nome" variant="outlined" size="small" fullWidth value={nome} onChange={(e) => setNome(e.target.value)} />

        <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#999', letterSpacing: 1, fontSize: 12 }}>
            E M A I L *
        </Typography>
        <TextField placeholder="E-mail" variant="outlined" size="small" fullWidth value={emailCad} onChange={(e) => setEmailCad(e.target.value)} />

        <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#999', letterSpacing: 1, fontSize: 12 }}>
            S E N H A *
        </Typography>
        <TextField placeholder="Senha" variant="outlined" size="small" type="password" fullWidth value={senhaCad} onChange={(e) => setSenhaCad(e.target.value)} />

        <FormControlLabel
            control={<Checkbox checked={ofertas} onChange={() => setOfertas(!ofertas)} sx={{ color: colors.goldColor }} />}
            label="Desejo receber ofertas e promoções"
            sx={{ color: 'var(--c-brand-primary)' }}
        />

        <FormControlLabel
            control={<Checkbox checked={aceitaTermos} onChange={() => setAceitaTermos(!aceitaTermos)} sx={{ color: colors.goldColor }} />}
            label={
            <span>
                Aceito os{' '}
                <Link href="#" sx={{ color: '#2070f0' }}>
                termos de uso
                </Link>{' '}
                *
            </span>
            }
            sx={{ color: 'var(--c-brand-primary)' }}
        />

        <Button btn-primary-6-big type="submit" variant="contained" sx={{ backgroundColor: colors.goldColor, fontWeight: 'bold', textTransform: 'uppercase', borderRadius: 1, py: 1.5, mt: 1 }}>
            CRIAR CONTA
        </Button>

        <Divider sx={{ my: 3, color: '#999' }}>Ou se cadastre usando</Divider>

        <SocialButtons />

        <Typography sx={{ mt: 3, fontSize: 13, color: colors.goldColor, textAlign: 'center' }}>
            Já possui uma conta?{' '}
            <Link href="#" onClick={(e) => { e.preventDefault(); setIsLogin(true); }} sx={{ color: colors.goldColor }}>
            Acesse aqui.
            </Link>
        </Typography>
        </Box>
    );
};

export default CadastroForm;
